import { CouponModel } from "../../../services/coupon/coupon.services";

/** Formata o desconto do cupom (valor em R$ ou percentual). */
export function formatDiscount(coupon: CouponModel): string {
    if (coupon.value) {
        return `R$ ${parseFloat(String(coupon.value)).toFixed(2).replace(".", ",")}`;
    }
    if (coupon.percentage !== null && coupon.percentage !== undefined) {
        return `${coupon.percentage}%`;
    }
    return "—";
}

/** Deriva a validade do cupom ("Válido" / "Expirado") a partir da data ou do enabled. */
export function getValidity(coupon: CouponModel): "Válido" | "Expirado" {
    if (coupon.expiration_date) {
        const isExpired = new Date(coupon.expiration_date) < new Date();
        return isExpired ? "Expirado" : "Válido";
    }
    return coupon.enabled ? "Válido" : "Expirado";
}
